import type { FieldOption } from './cfi-record.model';

/**
 * True when every option's value *is* its human label (race, ethnicity, sex).
 * False for id-valued lists (school GUID, grade number) and for an empty list.
 */
export function isLabelValued(options: FieldOption[]): boolean {
  return options.length > 0 && options.every((o) => o.label === String(o.value));
}
